/**
 * Created by Dhanya Akhil on 2/17/2017.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SanitizeHtmlPipe } from '../../shared/pipes/html-santizer.pipe'
import { CanActivateViaAuthGuard } from '../../shared/services/auth.service'
import { FaqRoutingModule } from './faq-routing.module';
import { FaqService } from './services/faq.service';
import { FaqComponent } from './components/faq.component';
import { FaqResourceApi } from '../../shared/services/api/faq-resource.api';

@NgModule({
  imports: [
    CommonModule,
    FaqRoutingModule,
    TranslateModule.forChild()
  ],
  declarations: [FaqComponent, SanitizeHtmlPipe],
  providers: [FaqService, CanActivateViaAuthGuard, FaqResourceApi]
})
export class FaqModule {
}
